(function () {
  function getVariantTag(variantEl) {
    var handle = variantEl.getAttribute('data-variant-handle');
    if (!handle) return null;
    return '#variant-' + handle;
  }

  function updateMainImage(variantEl) {
    var img = variantEl.getAttribute('data-img');
    var zoom = variantEl.getAttribute('data-zoom') || img;

    if (!img) return;

    var mainImg = document.querySelector('#ProductPhoto img, [id^="ProductPhotoImg"], .product__media-item img');
    var mainLink = document.querySelector('#ProductPhoto a, [id^="ProductPhotoLink"]');

    if (mainImg) {
      mainImg.src = img;
      mainImg.removeAttribute('srcset');
    }

    if (mainLink) {
      mainLink.href = zoom;
    }
  }

  function filterGallery(variantEl) {
    var tag = getVariantTag(variantEl);
    if (!tag || !window.jQuery) return;

    var $thumbs = jQuery('.product-single__thumbnails');

    if (!$thumbs.length) return;

    if ($thumbs.hasClass('slick-initialized')) {
      $thumbs.slick('slickUnfilter');

      $thumbs.slick('slickFilter', function () {
        var alt = jQuery(this).find('img').attr('alt') || '';
        alt = alt.toLowerCase();

        return alt.indexOf(tag) !== -1;
      });

      $thumbs.slick('slickGoTo', 0, true);
      $thumbs.slick('refresh');
    } else {
      jQuery('.product-single__thumbnail-item').each(function () {
        var alt = jQuery(this).find('img').attr('alt') || '';
        alt = alt.toLowerCase();

        if (alt.indexOf(tag) !== -1) {
          jQuery(this).show();
        } else {
          jQuery(this).hide();
        }
      });
    }
  }

  function applyVariant(variantEl) {
    if (!variantEl) return;

    updateMainImage(variantEl);

    setTimeout(function () {
      filterGallery(variantEl);
    }, 300);
  }

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
      var selected = document.querySelector('.variant-images_img.variant-selected');
      applyVariant(selected);
    }, 1000);
  });

  document.addEventListener('click', function (e) {
    var variantEl = e.target.closest('.variant-images_img');

    if (variantEl) {
      setTimeout(function () {
        applyVariant(variantEl);
      }, 300);
    }
  });
})();